var map = {
	"./0/data.json": 60856,
	"./1/data.json": 90813,
	"./10/data.json": 18909,
	"./11/data.json": 1144,
	"./12/data.json": 67479,
	"./13/data.json": 36058,
	"./14/data.json": 91041,
	"./15/data.json": 68604,
	"./16/data.json": 23835,
	"./17/data.json": 58702,
	"./18/data.json": 71397,
	"./19/data.json": 44896,
	"./2/data.json": 43962,
	"./20/data.json": 9984,
	"./21/data.json": 81413,
	"./22/data.json": 3650,
	"./23/data.json": 53727,
	"./24/data.json": 78948,
	"./3/data.json": 9751,
	"./4/data.json": 42748,
	"./5/data.json": 94369,
	"./6/data.json": 78830,
	"./7/data.json": 42395,
	"./8/data.json": 80064,
	"./9/data.json": 89957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91009;